import { render, staticRenderFns } from "./CalculadoraProcedimento.vue?vue&type=template&id=e9538a2a&scoped=true"
import script from "./CalculadoraProcedimento.vue?vue&type=script&lang=ts"
export * from "./CalculadoraProcedimento.vue?vue&type=script&lang=ts"
import style0 from "./CalculadoraProcedimento.vue?vue&type=style&index=0&id=e9538a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9538a2a",
  null
  
)

export default component.exports